"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consentAdvertiserOf = void 0;
function consentAdvertiserOf(ad) {
    var consentAdvertiser = ad
        .consentAdvertiser;
    if (undefined === consentAdvertiser) {
        return null;
    }
    return 0 === consentAdvertiser.categories.length ? null : consentAdvertiser;
}
exports.consentAdvertiserOf = consentAdvertiserOf;
